import * as React from 'react'

function CursorClickSelectIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.59 17.346l1.527 3.017a.554.554 0 01-.244.744l-1.646.833a.554.554 0 01-.744-.244l-1.527-3.017-2.632 1.647.006-9.135c0-.456.521-.716.886-.442l7.258 5.452-2.884 1.145v0zM5 11H3M21 11h-2M7.05 15.95l-1.41 1.41M18.36 4.64l-1.41 1.41M12 2v2M5.64 4.64l1.41 1.41"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { CursorClickSelectIcon }
